import { useTourContext } from '../contexts';
export var useShouldShowTourItem = function (flag) {
    var _a = useTourContext(), activeFlags = _a.activeFlags, completedFlags = _a.completedFlags;
    return activeFlags.includes(flag) && !completedFlags.includes(flag);
};
